























































































































































import { Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';
import * as E from '@/enums';

import AxAPI from '@/api';

type Group = I.AxZone;
type Item = I.SensorData;

type GroupListPanel = I.AxGroupListPanel<Group, Item>;
type PageInfo = I.SensorPageInfo;

type DataItem = U.DataItem<unknown, State>;
type DataStore = U.DataStore<unknown, never>;

const DataStore = U.DataStore;

class State {
  zoneCode: number;
  id: number | string;
  type: string;
  name: string;
  code: string;
  acuID: number;
  portUpper: number;
  portLower: number;
  relayPortUpper: number;
  relayPortLower: number;
  relayPort: number;
  schedule: string;
  cctv: string;
  sensorRescanTime: number;
  sensorType: string[];
  dialog: boolean;
  itemStatus: E.ItemStatus;

  constructor() {
    this.zoneCode = '' as never;
    this.id = '' as never;
    this.type = '' as never;
    this.name = '' as never;
    this.code = '' as never;
    this.acuID = '' as never;
    this.portUpper = '' as never;
    this.portLower = '' as never;
    this.relayPortUpper = '' as never;
    this.relayPortLower = '' as never;
    this.relayPort = '' as never;
    this.schedule = '' as never;
    this.cctv = '' as never;
    this.sensorRescanTime = '' as never;
    this.sensorType = '' as never;
    this.dialog = '' as never;
    this.itemStatus = E.ItemStatus.None;
  }
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  panel!: GroupListPanel;
  pageInfo!: PageInfo;
  dataItem!: DataItem;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  async getPageInfo() {
    const result = await this.API.call.sensor.get();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  // async updateItem(item: I.HolidayUpdateReq) {
  //   const result = await this.API.call.sensor.update(item);
  //   if (result instanceof Error) {
  //     await this.handleError(result);
  //     return false;
  //   } else {
  //     return result.data;
  //   }
  // }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '센서 데이터',
      store: {} as DataStore,
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }
}

@Component
class GroupPanelHandler extends BaseClass {
  onListGroupChanged(group?: Group) {
    if (!this.pageInfo || !group) return;

    if (this.panel.items) {
      this.panel.items = this.pageInfo.listSensor.filter(x => x.zoneCode === group.code);
    }
  }

  onListItemChanged(item?: Item) {
    if (item) {
      this.dataItem.state.itemStatus = E.ItemStatus.Update;

      this.dataItem.state.zoneCode = item.zoneCode;
      this.dataItem.state.id = item.code;
      this.dataItem.state.type = item.sensorType.toString();
      this.dataItem.state.name = item.name;

      this.dataItem.state.acuID = item.acuID;
      this.dataItem.state.portUpper = item.portUpper;
      this.dataItem.state.portLower = item.portLower;
      this.dataItem.state.relayPortUpper = 0;
      this.dataItem.state.relayPortLower = 0;

      this.dataItem.state.schedule = '사용 안함';
      this.dataItem.state.cctv = 'None';
      this.dataItem.state.sensorRescanTime = 123456;
    } else {
      this.dataItem.state = new State();
    }
  }

  onListAddClicked(group: Group) {
    this.dataItem.state = new State();
    this.dataItem.state.id = 0;
    this.dataItem.state.zoneCode = group.code;
    this.dataItem.state.itemStatus = E.ItemStatus.New;
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  panel: GroupListPanel = {
    groups: [],
    items: [],
    group: -1,
    item: -1
  };

  pageInfo = {} as PageInfo;

  get sensorType() {
    return this.pageInfo.listSensorType;
  }

  get sensorPortID() {
    if (this.dataItem.state.portUpper && this.dataItem.state.portLower) {
      return `${this.dataItem.state.portUpper}-${this.dataItem.state.portLower}`;
    } else {
      return '';
    }
  }

  get relayPortID() {
    if (this.dataItem.state.relayPortUpper && this.dataItem.state.relayPortLower) {
      return `${this.dataItem.state.relayPortUpper}-${this.dataItem.state.relayPortLower}`;
    } else {
      return '';
    }
  }
}

const Handlers = Mixins(ApiHandler, DataItemHandler, GroupPanelHandler);

@Component
export default class extends Mixins(BaseData, Handlers) {
  async prepare() {
    const pageInfo = await this.getPageInfo();

    console.log(pageInfo);

    if (pageInfo) {
      this.pageInfo = pageInfo;
      this.panel.groups = this.getZoneList();
    }
  }

  async onSaveClicked() {
    const { itemStatus } = this.dataItem.state;
    if (itemStatus === E.ItemStatus.None) return;

    await this.showConfirmModal('확인', '저장하시겠습니까?', ['예', '아니오']);
  }

  async onClearClicked() {
    const confirm = await this.showConfirmModal('확인', '입력중인 내용을 취소할까요?', [
      '네',
      '아니오'
    ]);

    if (confirm === 0) {
      this.dataItem.state = new State();
    }
  }

  async onDeleteClicked() {
    /* */
  }

  async onDetailConfigClicked() {
    const { zoneCode, acuID, portUpper, portLower } = this.dataItem.state;
    if ((acuID as never) === '' || (portUpper as never) === '' || (portLower as never) === '')
      return;

    this.showDialog({
      type: 'AxSensorDetailSettingDialog',
      props: {
        zoneCode,
        acuID,
        portUpper,
        portLower
      }
    });
  }

  showAcuPortSelectDialog() {
    if (this.dataItem.state.itemStatus === 'None') return;

    type AcuPortSelectTable = I.SensorExtData & {
      sensorTypeName: string;
      sensorName: string;
    };

    const store = new DataStore<AcuPortSelectTable>({
      headers: {
        acuID: { text: 'AxACU ID', width: 100, align: 'center' },
        extID: { text: '확장보드 ID', width: 100, align: 'center' },
        portID: { text: '포트', width: 100, align: 'center' },
        sensorID: { text: '센서 ID', width: 100, align: 'center' },
        sensorTypeName: { text: '센서 종류', width: 180, align: 'center' },
        sensorName: { text: '센서명', align: 'center' }
      }
    });

    const headers = store.headers;
    const items = (this.pageInfo.listExtSensor as AcuPortSelectTable[]).map(x => {
      const item = this.pageInfo.listSensor.find(sensor => sensor.code === x.sensorID);
      if (item) {
        x.sensorTypeName = item.typeName;
        x.sensorName = item.name;
      }
      return x;
    });
    const param: I.DataParam = {
      items,
      selected: [],
      headers,
      callback: async () => {
        const selected = param.selected as I.SensorExtData[];
        if (selected.length !== 1) return;

        this.dataItem.state.acuID = selected[0].acuID;
        this.dataItem.state.portUpper = selected[0].extID;
        this.dataItem.state.portLower = selected[0].portID;
      }
    };

    return this.showDialog({
      type: 'AxAcuPortSelectDialog',
      props: { param }
    });
  }

  showRelayPortSelectDialog() {
    if (this.dataItem.state.itemStatus === 'None') return;

    type AcuPortSelectTable = I.SensorExtData & {
      sensorTypeName: string;
      sensorName: string;
    };

    const items = [
      {},
      ...Array.from(Array(16).keys()).map(x => {
        return { extID: 14, portID: +(x + 1) };
      })
    ];

    const store = new DataStore<{}>({
      headers: {
        relayPort: { text: '릴레이 포트 ID', align: 'center' }
      }
    });

    const headers = store.headers;
    const param: I.DataParam = {
      items,
      selected: [],
      headers,
      callback: async () => {
        const selected = param.selected as I.SensorExtData[];
        if (selected.length === 0) {
          this.dataItem.state.relayPortUpper = 0;
          this.dataItem.state.relayPortLower = 0;
        } else if (selected.length === 1) {
          this.dataItem.state.relayPortUpper = selected[0].extID;
          this.dataItem.state.relayPortLower = selected[0].portID;
        }
      }
    };

    return this.showDialog({
      type: 'AxRelayPortSelectDialog',
      props: { param }
    });
  }
}
